import {CancelToken} from 'axios';
import {Effect} from 'effect';

import {projectsService} from 'api/projects';
import {TaskDependencyDto} from 'shared/models/TaskDependency';

import {ApiResponse} from '../BatchLoader';
import {EffectError, handleInteruptableErrors} from '../errors';

export const createProjecDepsEffect = ({projectId, taskIds}: {projectId: string; taskIds: string[]}) => {
  return (
    offset: number,
    take: number,
    cancelToken: CancelToken,
  ): Effect.Effect<ApiResponse<TaskDependencyDto>, EffectError, never> =>
    Effect.tryPromise({
      try: () =>
        projectsService.getTaskDependencies(projectId, taskIds, {
          offset,
          limit: take,
          cancelToken,
        }),
      catch: handleInteruptableErrors,
    }).pipe(
      Effect.map((response) => ({
        data: response.data.dependencies,
        headers: response.headers,
      })),
    );
};
